import { ref, readonly } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import { oneSignalService } from '@/services/oneSignalService'

// Clear notification-related session storage on logout
export const clearNotificationStorage = async () => {
  sessionStorage.removeItem('notificationRequestDismissed')
  sessionStorage.removeItem('oneSignalRegisteredUserId')
  await oneSignalService.clearRegistration()
}

export function useOneSignalRegistration() {
  const isRegistering = ref(false)
  const registrationError = ref<string | null>(null)

  const registerDeviceToken = async () => {
    if (isRegistering.value) return

    try {
      isRegistering.value = true
      registrationError.value = null

      const authStore = useAuthStore()
      const currentUserId = authStore.user?.id?.toString()

      if (!currentUserId) {
        throw new Error('User not authenticated')
      }

      console.log('🔔 Starting OneSignal registration for authenticated user:', currentUserId)

      // Use the centralized service to register device token
      await oneSignalService.registerDeviceToken(currentUserId)

      // Mark as registered for this session
      sessionStorage.setItem('oneSignalRegisteredUserId', currentUserId)

      console.log('✅ OneSignal registration completed successfully')
    } catch (error) {
      console.error('❌ OneSignal registration failed:', error)
      registrationError.value = error instanceof Error ? error.message : 'Registration failed'
      setTimeout(() => {
        registrationError.value = null
      }, 5000)
      throw error
    } finally {
      isRegistering.value = false
    }
  }

  return {
    registerDeviceToken,
    isRegistering: readonly(isRegistering),
    registrationError: readonly(registrationError),
  }
}
